import type { FC } from 'react'
import styled from '@emotion/styled'

import Image from '@segment/matcha/components/Image'
import Paper from '@segment/matcha/components/Paper'
import Typography from '@segment/matcha/components/Typography'

interface CardProps {
  author: string
  authorAvatar?: string
  description: string
}

const Card: FC<CardProps> = ({ description, author, authorAvatar }) => {
  return (
    <Paper background="transparent" borderRadius={10} elevation={2}>
      <Wrapper>
        <StyledDescription variant="pMedium">{description}</StyledDescription>
        <AccessoriesRow>
          {authorAvatar && <Author alt={author} src={authorAvatar} />}
          <Typography variant="textBoldSmall">{author}</Typography>
        </AccessoriesRow>
      </Wrapper>
    </Paper>
  )
}

const Author = styled(Image)`
  object-fit: cover;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin: 0;
`

const AccessoriesRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: left;
  gap: 8px;
`

const Wrapper = styled.div`
  padding: 32px;
`

const StyledDescription = styled(Typography)`
  margin-bottom: 36px;
`

export default Card
